﻿import { Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";
// import { SaveModalComponent } from '../shared/save-modal/save-modal.component';

@Component({
    selector: "bo-jubili",
    templateUrl: "./jubili.component.html",
    styleUrls: ["./jubili.component.scss"]
})

export class JubiliComponent implements OnInit {

    isToggle: boolean = false;
    main: string = "main-container";
    toggleStyle: string = "text-align:left;";

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService
    ) { }

    ngOnInit(): void {
        // Redirect to Dashboard

        const tempRoute = this.router.url;
        if (tempRoute === "/jubili/" || tempRoute === "/jubili") {
            this.router.navigate(["/jubili/dashboard"]);
        }
    }

    toggleSidebar(event: boolean): void {
        this.isToggle = event;

        // css main
        this.main = this.isToggle ? "toggle-main-container" : "main-container";
    }

    isToggleEvent(event: boolean): void {
      // css main
      this.main = event ? "toggle-main-container" : "main-container";
  }
}
